var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 152,
    viewBox: "0 0 178 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.4321 79.2322C22.4893 80.2563 12.1446 86.2343 5.94694 96.3189C-4.51717 113.346 0.802946 135.631 17.8297 146.096C34.8565 156.56 57.1423 151.24 67.6064 134.213C67.6065 134.213 67.6065 134.213 67.6065 134.213C101.66 155.141 146.232 144.501 167.16 110.447C188.088 76.3937 177.448 31.8222 143.394 10.8939C109.341 -10.0343 64.7692 0.605938 43.841 34.6595C35.3101 48.5407 32.0246 64.1695 33.4321 79.2322Z",
    fill: "#98DDD8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion);
export default __webpack_public_path__ + "static/media/Union.3d43a00572ddbca59ed400482863227a.svg";
export { ForwardRef as ReactComponent };